import { validateLocationByMode } from 'shared/utils/address';
import type { TCoordinatesFields, TAddressFields, ELocationMode } from 'components/trips/trip-create-task-modal/types';

export const validateReloadingFromForm = (
  warehouseId: number | undefined,
  locationMode: ELocationMode,
  coordinates: TCoordinatesFields,
  address: TAddressFields,
): boolean => {
  const hasWarehouse = warehouseId !== undefined;
  const hasLocation = validateLocationByMode(locationMode, coordinates, address);

  return hasWarehouse && hasLocation;
};
